import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HelperService } from '../../services/helper/helper.service';

@Component({
  selector: 'app-datetimepicker',
  template: `
    <input
      placeholder="Enter Date"
      [min]="min"
      [max]="max"
      [ngStyle]="newStyle"
      [owlDateTimeTrigger]="dt8"
      [owlDateTime]="dt8"
      (dateTimeChange)="onDateSelect($event)"
      class="{{ className }}"
      [(ngModel)]="date"
      readonly
    />
    <owl-date-time
      [disabled]="disabled"
      [startView]="startView"
      [pickerType]="pickerType"
      [hour12Timer]="onlyTime"
      pickerMode="dialog"
      #dt8
    ></owl-date-time>
  `,
})
export class DatetimepickerComponent implements OnInit {
  @Input() onlyDate = false;
  @Input() onlyTime = false;
  @Input() className = 'an-form-control';
  @Input() style = '';
  @Input() newStyle = {};
  @Input() startView = 'month';
  @Output() dateChange = new EventEmitter();

  private setInitial = false;

  @Input()
  set date(value) {
    this._date = value && this.helper.validateDate(value);
    if (value && this.setInitial) {
      this.setInitial = false;
      setTimeout(() => this.onDateSelect({ value }), 0);
    }
  }

  get date() {
    return this._date;
  }

  @Input()
  set minDate(value) {
    if (
      this.date &&
      this.helper.validateDate(this.date) < this.helper.validateDate(value)
    ) {
      this.date = this.helper.validateDate(value);
      setTimeout(() => this.onDateSelect({ value: this.date }), 0);
    }
    this.min = this.helper.validateDate(value) || new Date(null);
    if (this.onlyDate) {
      this.min.setHours(0, 0, 0);
    }
  }

  @Input()
  set maxDate(value) {
    if (
      this.date &&
      this.helper.validateDate(this.date) > this.helper.validateDate(value)
    ) {
      this.date = this.helper.validateDate(value);
      setTimeout(() => this.onDateSelect({ value: this.date }), 0);
    }
    this.max = this.helper.validateDate(value);
    if (this.onlyDate) {
      this.min && this.min.setHours(11, 59, 59);
    }
  }

  @Input() disabled = false;

  public pickerType: string;
  public min = null;
  public max = null;

  private _date = null;

  constructor(private helper: HelperService) {}

  ngOnInit() {
    // this.settings = {
    //   // bigBanner: true,
    //   timePicker: !this.onlyDate,
    //   format: this.onlyDate ? 'yyyy-MM-dd' : 'yyyy-MM-dd hh:mm a',
    //   closeOnSelect: true
    // }
    this.pickerType = this.onlyDate
      ? 'calendar'
      : this.onlyTime
      ? 'timer'
      : 'both';
  }

  onDateSelect(event) {
    this.dateChange.emit(HelperService.convertDate(event.value, this.onlyDate));
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/shared/datetimepicker/datetimepicker.component.ts